import { FETCH_TOPICS } from './constants'

export const fetchTopics = {
  request: (phoneId) => ({ type: FETCH_TOPICS.REQUEST, phoneId }),
  success: (topics, deviceId) => ({
    type: FETCH_TOPICS.SUCCESS,
    topics,
    deviceId
  })
}
